export const claimsMetaDataHistoryColumns = [
  'id',
  'submitter_org_name',
  'submitter_etin',
  'submitter_contact_type',
  'submitter_contact_phone',
  'receiver_org_name',
  'receiver_etin',
  'interchange_control_number',
  'interchange_control_version_number',
  'interchange_receiver_type',
  'interchange_receiver_id',
  'interchange_sender_type',
  'interchange_sender_id',
  'interchange_generated_date',
  'interchange_generated_time',
  'functional_group_id',
  'functional_group_receiver_code',
  'functional_group_control_number',
  'file_format',
  'delimiter',
  'trx_key',
  'meta_lineage_source_system_name',
  'meta_lineage_source_name',
  'meta_lineage_source_offset',
  'meta_load_dt',
  'meta_correlation_id',
  'meta_component',
  'snapshot_id',
  'meta_lineage_content_hash',
];
